import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

const REVIEWS = "reviews";

// Doc id = `${caseId}_${raterId}` → one review per rater per case.
// Bidirectional-ready: raterRole / revieweeRole let a designer review a lab in the future.
const reviewId = (caseId, raterId) => `${caseId}_${raterId}`;

export async function submitReview(caseId, data) {
  const id = reviewId(caseId, data.raterId);
  const ref = doc(db, REVIEWS, id);
  const snap = await getDoc(ref);
  const existed = snap.exists();
  if (existed) {
    await updateDoc(ref, {
      rating: data.rating,
      comment: data.comment || "",
      updatedAt: serverTimestamp(),
    });
  } else {
    await setDoc(ref, {
      id,
      caseId,
      raterId: data.raterId,
      raterRole: data.raterRole,
      raterName: data.raterName || "",
      revieweeId: data.revieweeId,
      revieweeRole: data.revieweeRole,
      rating: data.rating,
      comment: data.comment || "",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  }
  return existed;
}

export async function getReview(caseId, raterId) {
  try {
    const snap = await getDoc(doc(db, REVIEWS, reviewId(caseId, raterId)));
    return snap.exists() ? { id: snap.id, ...snap.data() } : null;
  } catch {
    return null;
  }
}

export async function listReviewsForReviewee(revieweeId) {
  try {
    const q = query(collection(db, REVIEWS), where("revieweeId", "==", revieweeId));
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch {
    return [];
  }
}

export async function getRatingSummary(revieweeId) {
  const reviews = await listReviewsForReviewee(revieweeId);
  const count = reviews.length;
  const avg = count ? reviews.reduce((s, r) => s + (r.rating || 0), 0) / count : 0;
  return { avg, count, reviews };
}
